import { isPgaLink } from 'lib/utils'

export const MARKETPLACE_LISTING_REASONS = {
  PROFILE_HIDDEN: 'profile-hidden',
  LEAD_LIMIT_REACHED: 'lead-limit-reached',
  LEAD_COLLECTION_DISABLED: 'lead-collection-disabled',
  NOT_BOOKABLE: 'not-bookable',
}

export const isExternalBookingUrl = url => {
  if (!url) return false

  try {
    return !isPgaLink(url)
  } catch {
    return false
  }
}

export const hasReachedLeadLimit = coach =>
  (coach?.freeTierLimitsReached ?? []).includes('LEADS')

export const canReceiveLeads = coach =>
  !hasReachedLeadLimit(coach) && Boolean(coach?.preferences?.acceptsLeads)

export const canBeBooked = coach =>
  Boolean(coach?.coachProfile?.bookable) ||
  isExternalBookingUrl(coach?.bookingUrl)

// Only ADM-complete coaches with a profile are candidates for the marketplace,
// so everyone else gets no reasons. Golfers need a way to reach a visible
// profile (leads and/or booking) for it to be indexed.
export const getMarketplaceListingReasons = coach => {
  const coachProfile = coach?.coachProfile

  if (!coach?.canPromoteContent || !coachProfile) {
    return []
  }

  const reasons = []

  if (coachProfile.status !== 'ACTIVE') {
    reasons.push(MARKETPLACE_LISTING_REASONS.PROFILE_HIDDEN)
  }

  if (!canReceiveLeads(coach) && !canBeBooked(coach)) {
    reasons.push(
      hasReachedLeadLimit(coach)
        ? MARKETPLACE_LISTING_REASONS.LEAD_LIMIT_REACHED
        : MARKETPLACE_LISTING_REASONS.LEAD_COLLECTION_DISABLED,
    )
    reasons.push(MARKETPLACE_LISTING_REASONS.NOT_BOOKABLE)
  }

  return reasons
}
